module.exports = __webpack_public_path__ + "img/energy.ea23ff06.svg";